<template>
  <BaseDialog
    v-model:visible="visible"
    dialogClass="rounded-[23.04px] overflow-hidden relative !w-[95%] sm:!w-[90%] md:!w-[80%] lg:!w-[70%] xl:!w-[60%] !max-w-[1051px] !h-[80vh] sm:!h-[85vh] md:!h-[90vh] !max-h-[694px]"
  >
    <div
      :style="{
        backgroundImage: `url(${dashboardBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '50% auto',
      }"
      class="relative z-10 flex flex-col items-center justify-center px-[24px] py-[48px] h-full gap-[24px] text-center"
    >
      <button
        v-if="showCancel"
        ref="closeButton"
        class="absolute top-[24px] right-[24px] cursor-pointer bg-transparent border-none"
        @click="visible = false"
        v-html="cancelSvg"
        :aria-label="$t('accessibilityLabels.closeSuccessDialog')"
        tabindex="0"
      ></button>

      <div class="pt-[29.5px]">
        <div
          class="flex justify-center items-center rounded-full bg-gradient-to-r from-mintGradientFrom to-mintGradientTo px-[30px] py-[35px]"
          v-html="successIcon"
        ></div>
      </div>
      <slot></slot>
    </div>
  </BaseDialog>
</template>

<script setup>
import { computed, ref, watch, nextTick } from "vue";
import { closeSvg, successSvg } from "@/utils/commonSvg";
const dashboardBg = new URL("@/assets/images/dashboard.png", import.meta.url).href;

const props = defineProps({
  modelValue: Boolean,
  showCancel: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const cancelSvg = closeSvg({ width: "25", height: "25", color: "#494949" });
const fullscreen = ref(false);

const successIcon = computed(() => {
  return successSvg({
    height: fullscreen.value ? "22" : "39",
    width: fullscreen.value ? "32" : "54",
  });
});

const checkScreenSize = () => {
  fullscreen.value = window.innerWidth < 768;
};

const closeButton = ref(null);

watch(
  visible,
  async (val) => {
    if (val) {
      await nextTick();
      setTimeout(() => {
        closeButton.value?.focus();
      }, 100);
    }
  },
  { immediate: true }
);


</script>
